// extracted by mini-css-extract-plugin
export var base = "panel-module--base--e77c9";
export var centered = "panel-module--centered--6e309";
export var centeredLeft = "panel-module--centeredLeft--fcaac";
export var noShadow = "panel-module--noShadow--c6007";